// Event log entry and note construction helpers.

import { EventEntry, Note } from '../models/general';
import { createDateTimeStamp } from './date.utils';

export function createEventRecord(
  event: string,
  original_values: {},
  altered_values: {},
  logged_in_user: string,
) {
  let event_entry = new EventEntry();
  event_entry.username = logged_in_user;
  event_entry.event = event;
  event_entry.value_changed_from = original_values;
  event_entry.value_changed_to = altered_values;
  event_entry.date_time_stamp = createDateTimeStamp();
  return event_entry;
}

export function buildEventRecord(
  sharedService: any,
  event: string,
  changed_from?: any,
  changed_to?: any,
) {
  const new_event_entry = new EventEntry();
  new_event_entry.date_time_stamp = createDateTimeStamp();
  new_event_entry.event = event;
  new_event_entry.username = sharedService.logged_in_user.username;
  new_event_entry.value_changed_from = changed_from ? changed_from : null;
  new_event_entry.value_changed_to = changed_to ? changed_to : null;
  return new_event_entry;
}

export function createNote(
  comment: string,
  type: string,
  sharedService: any,
): Note {
  const note = new Note();
  note.dateTime = createDateTimeStamp();
  note.comment = comment;
  note.username = sharedService.loggedInUser.username;
  note.note_type = type;
  return note;
}
